<script setup lang="ts">
import { toRefs } from "vue";
import { utc2local } from "@/utils";
import type { LegacyDevice } from "@/rvapi";
const props = defineProps<{
  device?: LegacyDevice;
  simple: boolean;
}>();
const { device, simple } = toRefs(props);
</script>

<template>
  <dl v-if="device">
    <dt>Customer Number</dt>
    <dd>{{ device?.customerNo }}</dd>
    <dt>Customer Email</dt>
    <dd>{{ device?.email }}</dd>
    <dt>Created at</dt>
    <dd>{{ utc2local(device?.registrationDate) }}</dd>
    <dt>Last used at</dt>
    <dd>{{ utc2local(device?.lastRegisterDeviceDate) }}</dd>
    <dt>Balance</dt>
    <dd>
      {{ device?.deviceBalance }}
      <pn-button
        v-show="device.deviceBalance && !simple"
        small="true"
        appearance="warning"
        :href="`/legacydevice/${device.deviceId}/migrate`"
      >
        Migrate to user
      </pn-button>
    </dd>
  </dl>
  <dl v-if="device && !simple">
    <dt v-show="!simple">Newsletter</dt>
    <dd v-show="!simple">{{ device?.newsletter }}</dd>
    <dt>App</dt>
    <dd>
      {{ device?.appName }} {{ device?.appVersion }} {{ device?.appStore }}
    </dd>
    <dt>Device</dt>
    <dd>
      {{ device?.deviceType }} {{ device?.deviceVersion }}
      {{ device?.deviceDescription }}
    </dd>
    <dt>Language</dt>
    <dd>{{ device?.languageIsoCode || "-" }} {{ device?.region }}</dd>
  </dl>
</template>
